<template>
    <div class="footer__logo">
        <div class="footer__logo">
        <a
            v-if="isAuth"
            :href="$getSubdomainLink('portal', '/home')"
        >
            <img src="@/assets/images/logo-footer.svg" :alt="appName" />
        </a>
        <a v-else :href="$getSubdomainLink('', '/')">
            <img src="@/assets/images/logo-footer.svg" :alt="appName" />
        </a>
    </div>
    </div>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
    data() {
        return {
            authStore: useAuthStore(),
            appName: import.meta.env.VITE_APPNAME,
        };
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
    },
};
</script>
